export const reportsRacingMultipleCrewsMultiplePieces = {
    namespaced: true,

    state: {
        filterFields: {
            pieces: [],
            crews: []
        },
        filter: {
            pieces: [],
            crews: []
        },
        table: {
            selectedTypes: ['time', 'distance', 'prognostic', 'strokeRate', 'eWPS', 'dps', 'pace'],
            sortOrder: null
        }
    },

    getters: {
        getFilter(state) {
            return state.filter;
        },

        getFilterFields(state) {
            return state.filterFields;
        },

        selectedTypes(state) {
            return state.table.selectedTypes;
        },

        sortOrder(state) {
            return state.table.sortOrder;
        }
    },

    mutations: {
        togglePiece(state, payload) {
            const indexOf = state.filter.pieces.indexOf(payload.piece.id);

            if (payload.event && indexOf === -1) {
                Vue.set(state.filter.pieces, state.filter.pieces.length, payload.piece.id);
            } else if (!payload.event && indexOf !== -1) {
                state.filter.pieces.splice(indexOf, 1);
            }
        },

        setFilterFieldsPiece(state, payload) {
            state.filterFields.pieces = payload;
        },

        toggleCrew(state, payload) {
            const indexOf = state.filter.crews.indexOf(payload.crew.id);

            if (payload.event && indexOf === -1) {
                Vue.set(state.filter.crews, state.filter.crews.length, payload.crew.id);
            } else if (!payload.event && indexOf !== -1) {
                state.filter.crews.splice(indexOf, 1);
            }
        },

        setFilterFieldsCrews(state, payload) {
            state.filterFields.crews = payload;
        },

        selectType(state, { event, type }) {
            const index = state.table.selectedTypes.indexOf(type);
            if (event) {
                index === -1 && state.table.selectedTypes.push(type);
            } else {
                index !== -1 && state.table.selectedTypes.splice(index, 1);
            }
        },

        setSortOrder(state, sortOrder) {
            state.table.sortOrder = sortOrder;
        },

        resetState(state) {
            state.filterFields = {
                pieces: [],
                crews: []
            };
            state.filter = {
                pieces: [],
                crews: []
            };
            state.table = {
                selectedTypes: ['time', 'prognostic', 'strokeRate', 'eWPS', 'dps', 'pace'],
                sortOrder: null
            };
        }
    },

    actions: {
        togglePiece({ commit }, payload) {
            commit('togglePiece', payload);
        },

        setFilterPieces({ commit }, payload) {
            commit('setFilterFieldsPiece', payload);
            payload.forEach(piece => commit('togglePiece', { event: true, piece }));
        },

        setFilterCrews({ commit }, payload) {
            commit('setFilterFieldsCrews', payload);
            payload.forEach(crew => commit('toggleCrew', { event: true, crew }));
        }
    }
};

export default reportsRacingMultipleCrewsMultiplePieces;
